export default "__VITE_ASSET__0W4dcS8o__"